import Shortcut from "@/components/shortcut";
import { getPresetShortcutDetails } from "@/data/preset-shortcut-details";
import { PositionInfo } from "@/types";
import { JSX } from "react";

interface PresetShortcutProps {
	dragId: string;
	isDraggable: boolean;
	isInDock: boolean;
	id?: string;
	setIsShortcutTitleShown?: (isShown: boolean) => void;
	setShortcutTitlePosition?: (position: PositionInfo) => void;
	setShortcutTitleText?: (text: string) => void;
	title: string;
}

function PresetShortcut({
	dragId,
	isDraggable,
	isInDock,
	id,
	setIsShortcutTitleShown,
	setShortcutTitlePosition,
	setShortcutTitleText,
	title,
}: PresetShortcutProps): JSX.Element {
	const allPresetDetails = getPresetShortcutDetails();

	const item = allPresetDetails[title];
	if (!item) {
		return <></>;
	}
	item.id = id;
	return (
		<Shortcut
			dragId={dragId}
			hasPopup={item.hasPopup}
			isDraggable={isDraggable}
			isInDock={isInDock}
			item={item}
			setIsShortcutTitleShown={setIsShortcutTitleShown}
			setShortcutTitlePosition={setShortcutTitlePosition}
			setShortcutTitleText={setShortcutTitleText}
		/>
	);
}

export default PresetShortcut;
